import type {
  DynamicBlock,
  QueryAvailableDynamicBlocksArgs,
} from '@tribeplatform/gql-client/types'
import type { DynamicBlockFields } from '@tribeplatform/gql-client/types/generated'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAvailableDynamicBlocksKey } from '../../utils/keys/app.key.js'

export const useAvailableDynamicBlocks = (options: {
  variables: QueryAvailableDynamicBlocksArgs
  fields?: DynamicBlockFields
  useQueryOptions?: UseQueryOptions<DynamicBlock[]>
}) => {
  const { variables, fields = 'basic', useQueryOptions } = options
  const { client } = useTribeClient()
  const dynamicBlockKey = getAvailableDynamicBlocksKey({ variables, fields })

  return useQuery<DynamicBlock[]>(
    dynamicBlockKey,
    () =>
      client.query({
        name: 'availableDynamicBlocks',
        args: { fields, variables },
      }),
    useQueryOptions,
  )
}
